module.exports = __webpack_public_path__ + "static/codepen-0c190a1350edd2f0221728bf2dd8aacc.png";